import React from 'react';
import { ZfAccordion, ZfBox, ZfDrawerHeader, ZfDrawerFooter, ZfStack, ZfTextButton, ZfTypography } from '@zafire/react';
import { StatusPill } from './StatusPill';
import { useDispatch } from 'react-redux';
import { clearSelectedPBProduct } from '../../reducers/privateBankingReducer';
import { ServiceAgreementV2 } from './eBankingTempTypes';
import { getProductDisplayName } from './mappers/serviceAgreementToTreeMapper';
import { BlockRenderer, getProductDetailsBlocks } from './productDetails/blockRegistry';
import { isSafeDepositBoxServiceDefinitionId } from './privateBankingServiceDefinitionIds';
import { useTranslation } from 'react-i18next';

type PrivateBankingProductDetailsProps = {
  product: ServiceAgreementV2;
};

const PrivateBankingProductDetails: React.FC<PrivateBankingProductDetailsProps> = ({ product }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onClose = () => dispatch(clearSelectedPBProduct());
  const blocks = getProductDetailsBlocks(product);
  const productTitle = isSafeDepositBoxServiceDefinitionId(product.serviceDefinitionId)
    ? t('pb.productdetails.safedepositbox.title')
    : getProductDisplayName(product) || '-';

  return (
    <ZfBox style={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <ZfDrawerHeader onClick={onClose}>Product Details</ZfDrawerHeader>

      <ZfStack
        id="private-banking-details-container"
        spacing="medium"
        style={{
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          minHeight: 0,
          overflowY: 'auto',
        }}
      >
        <ZfStack direction="row" spacing="small">
          <ZfTypography variant="body-large">{productTitle}</ZfTypography>
          <StatusPill status={product.agreementStatus} clickable={false} />
        </ZfStack>

        <ZfAccordion type="multiple">
          {blocks.map((blockConfig) => (
            <BlockRenderer key={blockConfig.type} config={blockConfig} product={product} />
          ))}
        </ZfAccordion>
      </ZfStack>

      <ZfDrawerFooter>
        <ZfTextButton slot="primary" hierarchy="tertiary" size="small" onClick={onClose}>
          Cancel
        </ZfTextButton>
      </ZfDrawerFooter>
    </ZfBox>
  );
};

export default PrivateBankingProductDetails;
